var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("nav", { staticClass: "navbar" }, [
      _c(
        "div",
        { staticClass: "nav-left flex", staticStyle: { "max-width": "70%" } },
        [
          _c("button", {
            staticClass: "btn btn-back nav-back mr-1",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                _vm.$router.push("/contracts")
              }
            }
          }),
          _vm._v(" "),
          _vm.$route.name === "ContractCreate"
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.name,
                    expression: "name"
                  }
                ],
                staticClass: "contract-name",
                class: _vm.errors.errors.name ? "contract-name-error" : "",
                attrs: { type: "text", placeholder: "Enter contract name" },
                domProps: { value: _vm.name },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.name = $event.target.value
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.$route.name === "ContractEdit"
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.contName,
                    expression: "contName"
                  }
                ],
                staticClass: "contract-name",
                class: _vm.errors.errors.name ? "contract-name-error" : "",
                attrs: { type: "text", placeholder: "Enter contract name" },
                domProps: { value: _vm.contName },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.contName = $event.target.value
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("error-field", { attrs: { errors: _vm.errors, field: "name" } }),
          _vm._v(" "),
          _vm.contractTypes.length
            ? _c(
                "div",
                {
                  staticClass: "select",
                  staticStyle: { "min-width": "150px" }
                },
                [
                  _c("label", { staticClass: "assignee-title pl-3" }, [
                    _vm._v("Select contract type")
                  ]),
                  _vm._v(" "),
                  _vm.$route.name === "ContractCreate"
                    ? _c("simple-select", {
                        staticClass: "assignee-content",
                        attrs: {
                          placeholder: "Select option",
                          options: _vm.contractTypes,
                          label: "name"
                        },
                        model: {
                          value: _vm.contType,
                          callback: function($$v) {
                            _vm.contType = $$v
                          },
                          expression: "contType"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$route.name === "ContractEdit"
                    ? _c("simple-select", {
                        staticClass: "assignee-content",
                        attrs: {
                          placeholder: _vm.contractType.id
                            ? _vm.contractType.name
                            : "Select option",
                          options: _vm.contractTypes,
                          label: "name"
                        },
                        model: {
                          value: _vm.contractType.id,
                          callback: function($$v) {
                            _vm.$set(_vm.contractType, "id", $$v)
                          },
                          expression: "contractType.id"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$route.name === "ContractCreate"
            ? _c("div", { staticClass: "flex" }, [
                _c(
                  "div",
                  { staticClass: "select" },
                  [
                    !_vm.errors.errors.company_id
                      ? _c("label", { staticClass: "assignee-title pl-3" }, [
                          _vm._v("Select company")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("key-multiselect", {
                      attrs: {
                        options: _vm.companies,
                        multiple: true,
                        "preserve-search": false,
                        label: "name",
                        "track-by": "id",
                        limit: _vm.companies.length,
                        "hide-selected": true
                      },
                      model: {
                        value: _vm.companyList,
                        callback: function($$v) {
                          _vm.companyList = $$v
                        },
                        expression: "companyList"
                      }
                    }),
                    _vm._v(" "),
                    _c("error-field", {
                      attrs: { errors: _vm.errors, field: "company_id" }
                    })
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.$route.name === "ContractEdit"
            ? _c("div", { staticClass: "nav-center flex flex-column" }, [
                _c(
                  "div",
                  { staticClass: "select" },
                  [
                    !_vm.errors.errors.company_id
                      ? _c("label", { staticClass: "assignee-title pl-3" }, [
                          _vm._v("Select company")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("key-multiselect", {
                      attrs: {
                        options: _vm.companies,
                        multiple: true,
                        "preserve-search": false,
                        "hide-selected": true,
                        label: "name",
                        "track-by": "id",
                        limit: _vm.companies.length
                      },
                      model: {
                        value: _vm.contCompanies,
                        callback: function($$v) {
                          _vm.contCompanies = $$v
                        },
                        expression: "contCompanies"
                      }
                    }),
                    _vm._v(" "),
                    _c("error-field", {
                      attrs: { errors: _vm.errors, field: "company_id" }
                    })
                  ],
                  1
                )
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "nav-right flex" }, [
        _vm.$route.name === "ContractEdit"
          ? _c(
              "button",
              {
                staticClass: "btn btn-secondary nav-item",
                on: {
                  click: function($event) {
                    _vm.$emit(
                      "preview",
                      _vm.contractName,
                      _vm.contCompanies,
                      _vm.active
                    )
                  }
                }
              },
              [_vm._v("\n        Preview PDF\n      ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.$route.name === "ContractCreate"
          ? _c(
              "button",
              {
                staticClass:
                  "btn btn-primary nav-item flex flex-column save-button",
                attrs: {
                  disabled:
                    !_vm.companyList.length || !_vm.name || !_vm.contractType
                },
                on: {
                  click: function($event) {
                    _vm.$emit(
                      "save",
                      _vm.name,
                      _vm.companyList,
                      _vm.contractActive
                    )
                  }
                }
              },
              [_c("span", [_vm._v("\n          Create contract\n        ")])]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.$route.name === "ContractEdit"
          ? _c(
              "button",
              {
                staticClass:
                  "btn btn-primary nav-item flex flex-column save-button",
                attrs: {
                  disabled:
                    !_vm.contCompanies.length ||
                    !_vm.contName ||
                    !_vm.contractType.id
                },
                on: {
                  click: function($event) {
                    _vm.$emit(
                      "save",
                      _vm.contractName,
                      _vm.contCompanies,
                      _vm.contractActive
                    )
                  }
                }
              },
              [
                _c("span", { staticClass: "button-text" }, [
                  _vm._v("\n          Save contract\n        ")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "button-time" }, [
                  _vm._v(
                    "\n          Last saved on " +
                      _vm._s(_vm.contractUpdated) +
                      "\n        "
                  )
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "dropdown dropleft" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dropdown-menu",
              attrs: { "aria-labelledby": "dropdownMenuButton" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.deleteContract($event)
                }
              }
            },
            [
              _c("form", { attrs: { "submit.prevent": "deleteContract" } }, [
                _c(
                  "div",
                  { staticClass: "switchToggle flex justify-content-between" },
                  [
                    _c("span", [_vm._v("Contract active")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.contActive,
                          expression: "contActive"
                        }
                      ],
                      attrs: {
                        type: "checkbox",
                        id: "switch1",
                        value: "false"
                      },
                      domProps: {
                        checked: Array.isArray(_vm.contActive)
                          ? _vm._i(_vm.contActive, "false") > -1
                          : _vm.contActive
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.contActive,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = "false",
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.contActive = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.contActive = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.contActive = $$c
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "switch1" } }, [
                      _vm._v("Toggle")
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.$route.name === "ContractEdit"
                  ? _c("div", { staticClass: "dropdown-divider" })
                  : _vm._e(),
                _vm._v(" "),
                _vm.$route.name === "ContractEdit"
                  ? _c(
                      "button",
                      {
                        staticClass: "dropdown-item",
                        attrs: { href: "#", type: "submit" }
                      },
                      [
                        _c("i", { staticClass: "fa fa-trash menu-icon" }),
                        _vm._v(" Delete contract\n            ")
                      ]
                    )
                  : _vm._e()
              ])
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-secondary nav-item nav-menu-button",
        attrs: {
          id: "dropdownMenuButton",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false"
        }
      },
      [_c("i", { staticClass: "fa fa-ellipsis-v text-dark" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04ee7e20", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04ee7e20","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contracts/ContractNavbar.vue
// module id = null
// module chunks = 